import { hasOwnProperty, serialize } from '../helper/utils.js';
import { isFormData, isFunction, isEmptyString } from '../helper/validator.js';

const interceptors = {
  request: (config) => config,
  response: {
    success: (response) => response,
    fail: (response) => Promise.reject(response)
  }
};
let baseUrl = '';

async function doFetch({ url, method, body, params, headers = { 'Content-Type': 'application/json' }, options = {} }) {
  options.method = method.toUpperCase();
  options.headers = headers;

  if (params) {
    url += serialize(params);
  }

  if (body) {
    options.body = isFormData(body) ? body : JSON.stringify(body);
  }

  options = interceptors.request(options);

  try {
    const _ = await fetch(baseUrl + url, options); //
    const response = options.responseType === 'text' ? await _.text() : await _.json();

    if (_.ok) {
      return interceptors.response.success(response);
    } else {
      throw new Error(response);
    }
  } catch (error) {
    return interceptors.response.fail(error);
  }
}

export default {
  setBaseUrl(url) {
    baseUrl = url;
  },
  getBaseUrl() {
    return baseUrl;
  },
  interceptors: {
    request(interceptor) {
      if (!isFunction(interceptor)) {
        throw TypeError('The interceptor must be of a function type.');
      }
      interceptors.request = interceptor;
    },
    response(successInterceptor, failInterceptor) {
      if (!isFunction(successInterceptor) || !isFunction(failInterceptor)) {
        throw TypeError('The interceptor must be of a function type.');
      }
      interceptors.response.success = successInterceptor;
      interceptors.response.fail = failInterceptor;
    }
  },
  async request(data) {
    if (!hasOwnProperty(data, 'url') || isEmptyString(data.url)) {
      throw TypeError('The url must be of a string type.');
    }
    return await doFetch(data);
  }
};
